export default "__VITE_ASSET__D$jP3nsq__"